export const upcomingEvents = [
  {
    id: 1,
    title: "Mommy & Me Yoga in the Park",
    date: "May 15, 2025",
    time: "10:00 AM",
    location: "Tribble Mill Park",
    category: "Wellness",
    image: "https://public.readdy.ai/ai/img_res/d718e845cd7051e600690de3624b8b81.jpg",
    spots: "12 spots left"
  },
  {
    id: 2,
    title: "Toddler Art & Craft Session",
    date: "May 18, 2025",
    time: "2:00 PM",
    location: "Gwinnett Place Community Center",
    category: "Creative",
    image: "https://readdy.ai/api/search-image?query=toddlers%20doing%20colorful%20art%20and%20crafts%20with%20mothers%20bright%20creative%20workspace%20with%20paint%20supplies%20and%20craft%20materials%20joyful%20learning%20environment%20community%20activity&width=800&height=600&seq=evt002&orientation=landscape",
    spots: "8 spots left"
  },
  {
    id: 3,
    title: "Mom's Night Out: Wine & Paint",
    date: "May 20, 2025",
    time: "7:00 PM",
    location: "Painted Pin",
    category: "Social",
    image: "https://readdy.ai/api/search-image?query=women%20painting%20on%20canvases%20in%20elegant%20studio%20setting%20with%20wine%20glasses%20sophisticated%20social%20gathering%20warm%20ambient%20lighting%20creative%20evening%20activity&width=800&height=600&seq=evt003&orientation=landscape",
    spots: "5 spots left"
  },
  {
    id: 4,
    title: "Playground Playdate Meetup",
    date: "May 22, 2025",
    time: "11:00 AM",
    location: "Vines Park",
    category: "Playdate",
    image: "https://readdy.ai/api/search-image?query=children%20playing%20on%20modern%20playground%20equipment%20with%20mothers%20socializing%20nearby%20sunny%20outdoor%20setting%20community%20connection%20vibrant%20family%20friendly%20atmosphere&width=800&height=600&seq=evt004&orientation=landscape",
    spots: "Open"
  }
];

export const weekendEvents = [
  {
    id: 1,
    title: "Gwinnett Farmers Market",
    day: "Saturday",
    time: "8:00 AM - 12:00 PM",
    location: "Lawrenceville Square",
    image: "https://readdy.ai/api/search-image?query=vibrant%20farmers%20market%20with%20fresh%20produce%20and%20vendor%20stalls%20families%20shopping%20outdoors%20sunny%20morning%20atmosphere%20local%20community%20gathering%20colorful%20vegetables%20and%20flowers&width=600&height=400&seq=wknd001&orientation=landscape"
  },
  {
    id: 2,
    title: "Story Time at the Library",
    day: "Saturday",
    time: "10:30 AM",
    location: "Gwinnett County Public Library",
    image: "https://readdy.ai/api/search-image?query=children%20sitting%20in%20circle%20listening%20to%20story%20time%20at%20library%20colorful%20books%20and%20reading%20area%20engaging%20educational%20environment%20warm%20welcoming%20atmosphere&width=600&height=400&seq=wknd002&orientation=landscape"
  },
  {
    id: 3,
    title: "Family Movie in the Park",
    day: "Sunday",
    time: "7:00 PM",
    location: "Lilburn City Park",
    image: "https://readdy.ai/api/search-image?query=outdoor%20movie%20screening%20at%20dusk%20with%20families%20on%20blankets%20large%20screen%20in%20park%20setting%20community%20gathering%20evening%20atmosphere%20cozy%20family%20entertainment&width=600&height=400&seq=wknd003&orientation=landscape"
  }
];

export const summerCamps = [
  {
    id: 1,
    name: "STEM Adventure Camp",
    ages: "6-12 years",
    dates: "June 5 - June 16",
    price: "$350/week",
    provider: "Discovery Point",
    image: "https://readdy.ai/api/search-image?query=children%20doing%20science%20experiments%20and%20robotics%20activities%20in%20bright%20classroom%20setting%20educational%20STEM%20learning%20environment%20engaging%20hands%20on%20activities%20colorful%20equipment&width=500&height=400&seq=camp001&orientation=landscape"
  },
  {
    id: 2,
    name: "Creative Arts Camp",
    ages: "5-10 years",
    dates: "June 19 - June 30",
    price: "$300/week",
    provider: "Art Studio Gwinnett",
    image: "https://readdy.ai/api/search-image?query=children%20creating%20art%20projects%20painting%20and%20crafting%20in%20colorful%20studio%20bright%20creative%20workspace%20with%20art%20supplies%20joyful%20artistic%20expression%20summer%20camp%20setting&width=500&height=400&seq=camp002&orientation=landscape"
  },
  {
    id: 3,
    name: "Sports & Recreation Camp",
    ages: "7-14 years",
    dates: "July 10 - July 21",
    price: "$325/week",
    provider: "Gwinnett Sports Academy",
    image: "https://readdy.ai/api/search-image?query=children%20playing%20various%20sports%20activities%20soccer%20basketball%20outdoor%20recreation%20sunny%20athletic%20field%20active%20healthy%20lifestyle%20summer%20camp%20environment&width=500&height=400&seq=camp003&orientation=landscape"
  },
  {
    id: 4,
    name: "Nature Explorers Camp",
    ages: "4-9 years",
    dates: "July 24 - August 4",
    price: "$280/week",
    provider: "Gwinnett Environmental Center",
    image: "https://readdy.ai/api/search-image?query=children%20exploring%20nature%20trails%20with%20magnifying%20glasses%20outdoor%20learning%20environment%20natural%20setting%20educational%20nature%20activities%20summer%20adventure%20camp&width=500&height=400&seq=camp004&orientation=landscape"
  }
];

export const localResources = [
  {
    id: 1,
    title: "Pediatricians",
    icon: "ri-heart-pulse-line",
    count: "24 providers"
  },
  {
    id: 2,
    title: "Daycares",
    icon: "ri-home-heart-line",
    count: "18 centers"
  },
  {
    id: 3,
    title: "Preschools",
    icon: "ri-book-read-line",
    count: "32 schools"
  },
  {
    id: 4,
    title: "Family Restaurants",
    icon: "ri-restaurant-line",
    count: "45 spots"
  },
  {
    id: 5,
    title: "Parks & Playgrounds",
    icon: "ri-plant-line",
    count: "28 locations"
  },
  {
    id: 6,
    title: "Kids Activities",
    icon: "ri-basketball-line",
    count: "36 venues"
  }
];

export const mamaApprovedBusinesses = [
  {
    id: 1,
    name: "Little Sprouts Photography",
    category: "Photography",
    description: "Specializing in newborn and family portraits",
    discount: "15% off for members",
    rating: 4.9,
    reviews: 127,
    image: "https://readdy.ai/api/search-image?query=professional%20photography%20studio%20setup%20for%20family%20portraits%20with%20soft%20lighting%20elegant%20backdrop%20camera%20equipment%20warm%20welcoming%20atmosphere%20newborn%20photography%20setting&width=600&height=500&seq=biz001&orientation=landscape"
  },
  {
    id: 2,
    name: "Tiny Toes Dance Studio",
    category: "Dance & Movement",
    description: "Ballet, tap, and creative movement for ages 2-12",
    discount: "Free trial class",
    rating: 5.0,
    reviews: 89,
    image: "https://readdy.ai/api/search-image?query=bright%20dance%20studio%20with%20mirrors%20and%20ballet%20barres%20young%20children%20in%20dance%20attire%20practicing%20movements%20colorful%20cheerful%20space%20professional%20dance%20instruction%20setting&width=600&height=500&seq=biz002&orientation=landscape"
  },
  {
    id: 3,
    name: "Sweet Dreams Sleep Consulting",
    category: "Parenting Support",
    description: "Certified sleep consultant for babies and toddlers",
    discount: "20% off first consultation",
    rating: 4.8,
    reviews: 64,
    image: "https://readdy.ai/api/search-image?query=peaceful%20nursery%20setting%20with%20sleeping%20baby%20in%20crib%20soft%20pastel%20colors%20gentle%20lighting%20cozy%20comfortable%20environment%20professional%20childcare%20atmosphere&width=600&height=500&seq=biz003&orientation=landscape"
  },
  {
    id: 4,
    name: "The Play Cafe",
    category: "Family Dining",
    description: "Kid-friendly cafe with indoor play area",
    discount: "10% off total bill",
    rating: 4.7,
    reviews: 203,
    image: "https://readdy.ai/api/search-image?query=modern%20family%20friendly%20cafe%20interior%20with%20colorful%20play%20area%20for%20children%20bright%20welcoming%20space%20comfortable%20seating%20healthy%20food%20display%20community%20gathering%20spot&width=600&height=500&seq=biz004&orientation=landscape"
  }
];

export const merchItems = [
  {
    id: 1,
    name: "Mommy Mingle Tote Bag",
    price: "$24.99",
    image: "https://readdy.ai/api/search-image?query=stylish%20canvas%20tote%20bag%20with%20modern%20logo%20design%20neutral%20color%20practical%20everyday%20bag%20clean%20product%20photography%20simple%20background&width=500&height=500&seq=merch001&orientation=squarish"
  },
  {
    id: 2,
    name: "Mix Mingle Memories Mug",
    price: "$16.99",
    image: "https://readdy.ai/api/search-image?query=ceramic%20coffee%20mug%20with%20inspirational%20quote%20design%20white%20or%20pastel%20color%20elegant%20typography%20clean%20product%20photography%20simple%20background&width=500&height=500&seq=merch002&orientation=squarish"
  },
  {
    id: 3,
    name: "Community Crew T-Shirt",
    price: "$28.99",
    image: "https://readdy.ai/api/search-image?query=comfortable%20cotton%20t-shirt%20with%20modern%20graphic%20design%20neutral%20color%20casual%20style%20clean%20product%20photography%20simple%20background&width=500&height=500&seq=merch003&orientation=squarish"
  },
  {
    id: 4,
    name: "Mama Approved Sticker Pack",
    price: "$8.99",
    image: "https://readdy.ai/api/search-image?query=colorful%20sticker%20sheet%20with%20fun%20designs%20for%20moms%20vibrant%20colors%20playful%20graphics%20clean%20product%20photography%20simple%20background&width=500&height=500&seq=merch004&orientation=squarish"
  }
];